import { useContext, useEffect, useMemo } from 'react';
import TableGrouping, { IColumnsGrouping } from '../../components/table-grouping/TableGrouping';
import AppContext from '../../../AppContext';
import { TYPE_REF, VARIABLE_STRING } from '../../constants/moduleConsts';
import useMultiLanguage from '../../../hook/useMultiLanguage';
import { LIST_ATTRIBUTION_OVERTIME } from '../constants/timesheetConsts';
import { checkWeekend, checkWeekendOrHoliday } from '../../utils/functionUtils';

function TableTimesheetOvertime(props: any) {
    const { refsArray, setRefsArray, data, dataKHChamCong, isView = true, dateSearch } = props;
    const { setPageLoading } = useContext(AppContext);
    const { lang } = useMultiLanguage();

    const listAttribution = LIST_ATTRIBUTION_OVERTIME;

    useEffect(() => {
        const dayOfMonth = new Date(dateSearch.nam, dateSearch?.thang, 0).getDate();
        const yellowTds = document.querySelectorAll("td.isWeekend");
        const theadRows = document.querySelectorAll("thead tr th");

        yellowTds.forEach((td) => {
            const colIndex = (td as HTMLTableCellElement).cellIndex;

            for (let i = theadRows.length - 1; i >= 0; i--) {
                const th1 = theadRows[colIndex + 2] as HTMLTableCellElement | null;
                const th2 = theadRows[colIndex + 2 + dayOfMonth + listAttribution.length] as HTMLTableCellElement | null;
                if (th1 && th2) {
                    th1.classList.add("isWeekend");
                    th2.classList.add("isWeekend");
                    break;
                }
            }
        });
    });

    const columns = ({ setRefsArray, dataKHChamCong, isView, dateSearch }: any): IColumnsGrouping[] => {
        const listColumn: IColumnsGrouping[] = [
            {
                name: "STT",
                field: "stt",
                render: (row: any, index: number, stt: number) => <span ref={setRefsArray && setRefsArray(index, VARIABLE_STRING.EMPLOYEE, TYPE_REF.AUTOCOMPLETE_REF, row?.id)}>{stt}</span>,
                isSticky: true,
            },
            {
                name: "Họ và tên",
                field: "employeeText",
                headerStyle: {
                    minWidth: "170px"
                },
                cellStyle: {
                    textAlign: "left"
                },
                isSticky: true,
            },
            {
                name: "Khoa phòng",
                field: "phongBanText",
                isSticky: true,
                headerStyle: {
                    minWidth: "200px"
                },
                cellStyle: {
                    textAlign: "left"
                },
            },
            {
                name: "Cấp bậc chức vụ",
                field: "chucDanhText",
                headerStyle: {
                    minWidth: "200px"
                },
                cellStyle: {
                    textAlign: "left"
                },
            },
        ];

        const listDate = [];
        const dayOfMonth = new Date(dateSearch.nam, dateSearch?.thang, 0).getDate();
        const weekdays = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];   

        for (let i = 1; i <= dayOfMonth; i++) {
            const currentDate = new Date(dateSearch.nam, dateSearch.thang - 1, i);
            const dayOfWeek = weekdays[currentDate.getDay()];
            listDate.push({
                name: String(i),
                field: `ngay${i}`,
                headerStyle: {
                    minWidth: "95px",
                },
                className: checkWeekend(dateSearch.nam, dateSearch.thang, i) ? `isWeekend` : '',
                cellClassName: (row: any, index: number) => {
                    return checkWeekendOrHoliday(row?.[`ngay${i}`]?.defaultCode) ? `isWeekend` : ''
                },
                child: [
                    {
                        name: dayOfWeek,
                        field: `thu${i}`,
                        headerStyle: {
                            minWidth: "95px",
                        },
                        className: checkWeekend(dateSearch.nam, dateSearch.thang, i) ? `isWeekend` : '',
                        cellClassName: (row: any, index: number) => {
                            return checkWeekendOrHoliday(row?.[`ngay${i}`]?.defaultCode) ? `isWeekend` : ''
                        },
                        render: (row: any, index: number) => {
                            return (
                                <span>{row?.[`ngay${i}`]?.soGioLamThem || ''}</span>
                            )
                        }
                    }
                ],
            });
        }

        listColumn.push({
            name: "Ngày trong tháng",
            field: "date",
            headerStyle: {
                minWidth: "180px"
            },
            child: listDate
        });

        const listStatistical: IColumnsGrouping[] = [];
        listAttribution.forEach((attribution) => {
            listStatistical.push({
                name: attribution?.name,
                field: attribution?.fieldName,
                headerStyle: {
                    minWidth: "180px"
                },
            })
        });

        listColumn.push({
            name: "Cộng số giờ làm thêm",
            field: "statistical",
            headerStyle: {
                minWidth: "180px"
            },
            child: listStatistical
        });
        
        return listColumn;
    }
    
    const memoizedTable = useMemo(
        () => {
            setTimeout(() => !isView && setPageLoading(false), 10)
            if (refsArray) {
                refsArray.current = [];
            }
            return (
                <TableGrouping
                    className="table-custom"
                    id="timeSheets"
                    columns={columns({
                        setRefsArray,
                        dataKHChamCong,
                        isView,
                        dateSearch
                    })}
                    data={data}
                    prefixDataField="data"
                    prefixTitleField="phongBanText"
                />
            )
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [setRefsArray, data, dataKHChamCong, isView]
    );

    return (
        <div>{memoizedTable}</div>
    )
}

export default TableTimesheetOvertime